import { AppError } from './errors';

class StorageManager {
  private static instance: StorageManager;
  private isAvailable: boolean;

  private constructor() {
    this.isAvailable = this.checkAvailability();
  }

  static getInstance(): StorageManager {
    if (!StorageManager.instance) {
      StorageManager.instance = new StorageManager();
    }
    return StorageManager.instance;
  }

  private checkAvailability(): boolean {
    try {
      const testKey = '__storage_test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  getItem<T>(key: string, defaultValue: T): T {
    if (!this.isAvailable) {
      return defaultValue;
    }

    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  }

  setItem(key: string, value: unknown): void {
    if (!this.isAvailable) {
      return;
    }

    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Silently fail - storage is non-critical
      console.debug('Storage write failed:', error);
    }
  }

  removeItem(key: string): void {
    if (!this.isAvailable) {
      return;
    }

    try {
      window.localStorage.removeItem(key);
    } catch {
      // Silently fail
    }
  }

  clear(): void {
    if (!this.isAvailable) {
      return;
    }

    try {
      window.localStorage.clear();
    } catch {
      // Silently fail
    }
  }
}

export const storage = StorageManager.getInstance();